import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import translate from "i18n/translate";
import { authSaveSessionData } from "redux/auth/actions";
import { INVALID_CREDENTIAL_EXCEPTION } from "constants/apiErrorCodes.constant";
import {
  AUTH_ROOT_ROUTE,
  PHONE_VERIFICATION_ROUTE,
} from "routes/auth/authPaths";
import basicAuthRequest from "axios/basicAuthRequest";

const businessLineRequest = async () => {
  try {
    return await basicAuthRequest.get("/catalog/business");
  } catch (error) {
    return error;
  }
};

const useRegister = () => {
  const publicIp = useSelector(({ auth }) => auth.publicIp);
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const [emailAndPassword, setEmailAndPassword] = useState();
  const [userAndBusiness, setUserAndBusiness] = useState();
  const [address, setAddress] = useState();
  const [businessLines, setBusinessLines] = useState([]);

  useEffect(() => {
    const getBusinessLine = async () => {
      const result = await businessLineRequest();
      setBusinessLines(result?.data?.result);
    };
    getBusinessLine();
  }, []);

  const onSubmitFirstStep = async (values, actions) => {
    let isValid = false;

    try {
      const response = await basicAuthRequest.post(
        "/user/email/status",
        values
      );

      if (response.data.result?.email) {
        actions.setFieldError("email", translate("auth.emailExist"));
      } else {
        setEmailAndPassword(values);
        isValid = true;
      }
    } catch (error) {
      if (error.response?.data?.error?.code === INVALID_CREDENTIAL_EXCEPTION) {
        actions.setFieldError("email", translate("errors.emailExists"));
      } else {
        const errorMsg =
          error.response?.data?.error?.message ??
          translate("errors.somethingWrong");

        actions.setFieldError("main", errorMsg);
      }
    }

    return isValid;
  };

  const onSubmitSecondStep = (values) => {
    setUserAndBusiness(values);
    return true;
  };

  const onSubmitThirdStep = async (values, actions) => {
    setAddress(values);

    const data = {
      name: userAndBusiness.firstName,
      last_name: userAndBusiness.firstLastName,
      sur_name: userAndBusiness.secondLastName,
      area: values.area,
      city: values.city,
      state: values.state,
      street: values.street,
      zip_code: values.zipCode,
      num_ext: values.numExt,
      num_int: values.numInt,
      label: "Personal", // Address type
      ip: publicIp,
      company: {
        bussines_id: userAndBusiness.businessLine,
        name: userAndBusiness.businessName,
      },
      user: {
        email: emailAndPassword.email,
        password: emailAndPassword.password,
      },
      phone: {
        number: userAndBusiness.phoneNumber,
        label: "celular", // Phone type
      },
      code: params.code,
    };

    try {
      const response = await basicAuthRequest.post("/register", data);

      const {
        result: { token },
        connectionSso: { accessToken } = {},
      } = response.data;

      dispatch(authSaveSessionData({ token, accessToken }));
      history.push(AUTH_ROOT_ROUTE + PHONE_VERIFICATION_ROUTE);
    } catch (error) {
      const errorMsg =
        error.response?.data?.error?.message ??
        translate("errors.somethingWrong");

      actions.setFieldError("main", errorMsg);
    }
  };

  return {
    stepOne: {
      onSubmit: onSubmitFirstStep,
      currentState: emailAndPassword,
    },
    stepTwo: {
      onSubmit: onSubmitSecondStep,
      currentState: userAndBusiness,
      setCurrentState: setUserAndBusiness,
      businessLines,
    },
    stepThree: {
      onSubmit: onSubmitThirdStep,
      currentState: address,
      setCurrentState: setAddress,
    },
  };
};

export default useRegister;
